import { create } from "zustand";
import { devtools } from "zustand/middleware";
import type { User } from "./types";

interface AuthState {
  user: null | User;
  setUser: (user: User) => void;
  logout: () => void;
  notificationCount: number;
  setNotificationCount: (value: number) => void;
  chatUnreadCount: number;
  setChatUnreadCount: (value: number) => void;
}

export const useAuthStore = create<AuthState>()(
  devtools((set) => ({
    user: null,
    setUser: (user) => set({ user }),
    logout: () => set({ user: null }),
    notificationCount: 0,
    setNotificationCount: (value: number) => set({ notificationCount: value }),
    chatUnreadCount: 0,
    setChatUnreadCount: (value: number) => set({ chatUnreadCount: value }),
  }))
);

type OrderState = {
  createOrder: boolean;
  setCreateOrder: (open: boolean) => void;
};

export const useOrderStore = create<OrderState>((set) => ({
  createOrder: false,
  setCreateOrder: (open: boolean) => set({ createOrder: open }),
}));

type ViewType = {
  view: "Kanban" | "Table";
  setView: (view: "Kanban" | "Table") => void;
};

export const useDashboardView = create<ViewType>((set) => ({
  view: "Kanban",
  setView: (view) => set({ view }),
}));

interface SessionState {
  sessionExpired: boolean;
  setSessionExpired: (value: boolean) => void;
}

export const useSessionStore = create<SessionState>((set) => ({
  sessionExpired: false,
  setSessionExpired: (value) => set({ sessionExpired: value }),
}));
